
const IntroSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-800 mb-8">
            住まいに関するあらゆるサポートを、ひとつの窓口で。
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            不動産の売買・賃貸・リフォーム・空き家相談まで。<br />
            地域の特性を知り尽くしたスタッフが、あなたに最適なプランをご提案します。
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
